import React from 'react';
import Button from '../../../../pages/ui/Button/Button';
import styles from './CardButtons.module.scss';

export default function CardButtons({
  hasBorder = false,
  aboutButtonText,
  aboutButtonUrl,
  contactButtonText,
  contactButtonUrl,
}) {
  // 获取按钮文本，如果没有提供则使用默认值
  const getAboutButtonText = () => {
    if (aboutButtonUrl && aboutButtonUrl.href) {
      return aboutButtonText || 'Find out more';
    }
    return aboutButtonText || 'Find out more';
  };

  const getContactButtonText = () => {
    if (contactButtonUrl && contactButtonUrl.href) {
      return contactButtonText || 'Book a test drive';
    }
    return contactButtonText || 'Book a test drive';
  };

  // 获取按钮链接
  const getAboutButtonUrl = () => {
    if (aboutButtonUrl && aboutButtonUrl.href) {
      return `${aboutButtonUrl?.href || ''}${aboutButtonUrl?.querystring || ''}`;
    }
    return '/about-us';
  };

  const getContactButtonUrl = () => {
    if (contactButtonUrl && contactButtonUrl.href) {
      return `${contactButtonUrl?.href || ''}${contactButtonUrl?.querystring || ''}`;
    }
    return '/contact-us';
  };

  return (
    <div className={styles.buttons}>
      <Button
        className={`${styles.button} ${hasBorder ? styles.button_bordered : ''}`}
        variant="secondary"
        target={getAboutButtonUrl()}
      >
        {getAboutButtonText()}
      </Button>
      <Button
        className={`${styles.button} ${hasBorder ? styles.button_bordered : ''}`}
        variant="primary"
        target={getContactButtonUrl()}
      >
        {getContactButtonText()}
      </Button>
    </div>
  );
}
